import React from "react";
import Drawer from "./Drawer.jsx";
import Waitlist from "./Waitlist.jsx";
import ProductColors from "./ProductColors.jsx";
import ProductPromos from "./ProductPromos.jsx";
import ProductSwitcher from "./ProductSwitcher.jsx";
import LowerProductSwitcher from "./LowerProductSwitcher.jsx";
import Axios from "axios";
import CartMini from "../components/CartMini";
import ProductContext from "./ProductContext.jsx";
import SVG from "./SVG.jsx";
import trackEvent from "../utils/trackEvent";
import { formatMoney } from "@shopify/theme-currency";
import EstimatedDelivery from "./EstimatedDelivery.jsx";
export default class ProductForm extends React.PureComponent {
  constructor(props) {
    super();

    this.state = {
      cartButton: "",
      invalidVariant: false,
      shipModalOpen: false,
    };

    this._optionChanged = this._optionChanged.bind(this);
    this._invalidVariant = this._invalidVariant.bind(this);
    this.formData = this.formData.bind(this);
    this.inventoryAlert = this.inventoryAlert.bind(this);
    this.formButton = this.formButton.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.waitlist = this.waitlist.bind(this);
    this.shipNote = this.shipNote.bind(this);

    this._openShipModal = this._openShipModal.bind(this);
    this._closeShipModal = this._closeShipModal.bind(this);

    this.cartMini = new CartMini();

    this.ref = React.createRef();
    // window.dataLayer = window.dataLayer || [];
  }

  _openShipModal(e) {
    e.preventDefault();
    this.setState({ shipModalOpen: true });
  }

  _closeShipModal() {
    this.setState({ shipModalOpen: false });
  }

  _optionChanged(name, value) {
    this.props.onOptionChange(name, value);
  }

  _invalidVariant() {
    this.setState({ invalidVariant: true }, () => {
      this.ref.current.scrollIntoView({ behavior: "smooth" });
    });

    for (let i = 0; i < this.props.product.options.length; i++) {
      const keyName = `option${i + 1}`;
      if (!this.props[keyName]) {
        // window.dataLayer.push({ 'event': 'ATC Option Unselected', 'option_unselected': this.props.product.options[i] });
      }
    }
  }

  formData() {
    if (this.props.product.variants.length === 1) {
      return null;
    }

    const productEn = this.props.product.en;

    return this.props.product.options_with_values.map((option, i) => {
      const keyName = `option${i + 1}`;
      let cName = "option-wrapper";

      if (productEn.options_with_values[i].name === "Size") {
        cName += " option-handle-size";

        if (["boots", "Shoes", "Sneakers"].includes(this.props.product.type)) {
          cName += " localize-sizes";
        }
      }

      if (productEn.options_with_values[i].name === "Width") {
        cName += " option-handle-width";
      }
      if (productEn.options_with_values[i].name === "Fit") {
        cName += " option-handle-fit";
      }
      if (this.state.invalidVariant && !this.props[keyName]) {
        cName += " unselected";
      }
      if (this.props.product.tags.includes("extended-sizes")) {
        cName += " extended-sizes";
      }
      if (this.props.product.tags.includes("orphaned-size")) {
        cName += " orphaned-size";
      }
      if (this.props.product.tags.includes("fullwidth-sizes")) {
        cName += " fullwidth-sizes";
      }
      // Determine the display name for the option
      const isSizeOption = productEn.options_with_values[i].name === "Size";
      const isNonUSCountry = window.Theme && window.Theme.localizationCountry && window.Theme.localizationCountry !== 'US';
      const optionDisplayName = isSizeOption && isNonUSCountry ? "Size (US)" : option.name;

      return (
        <div className={cName} data-option-wrapper={productEn.options_with_values[i].name} key={i}>
          <div className="option-header">
            <span className="option-name">{optionDisplayName}: </span>
            {productEn.options_with_values[i].name === "Size" ? (
              <ProductPromos
                metafields={this.props.metafields}
                product={this.props.product}
                blocks={this.props.blocks}
                position="above-atc-smart-2"
                _openSizeGuide={this.props._openSizeGuide}
                _optionChanged={this._optionChanged}
                sizeGuides={this.props.sizeGuides}
              />
            ) : null}
            {productEn.options_with_values[i].name === "Fit" ? (
              <ProductPromos
                metafields={this.props.metafields}
                product={this.props.product}
                blocks={this.props.blocks}
                position="above-atc-smart-3"
                _openFitGuide={this.props._openFitGuide}
                _optionChanged={this._optionChanged}
                sizeGuides={this.props.sizeGuides}
              />
            ) : null}
          </div>
          {productEn.options_with_values[i].name === "Size" ? (
            <ProductPromos
              metafields={this.props.metafields}
              product={this.props.product}
              blocks={this.props.blocks}
              position="above-atc-smart"
              _openSizeGuide={this.props._openSizeGuide}
              _optionChanged={this._optionChanged}
              sizeGuides={this.props.sizeGuides}
            />
          ) : null}
          <div className="option-values">
            {option.values.map((optionValue, j) => {
              let optionValueLabel = optionValue;
              if (
                productEn.options_with_values[i].name === "Width" &&
                optionValue === "Wide" &&
                this.props.metafields.wideLabel
              ) {
                optionValueLabel = `${optionValue} ${this.props.metafields.wideLabel}`;
              }
              return (
                <div className="option-value" key={j}>
                  <input
                    type="radio"
                    name={productEn.options_with_values[i].name}
                    value={optionValue}
                    checked={this.props[keyName] === optionValue}
                    className="option-value-input"
                    id={`${this.props.product.handle}-${productEn.options_with_values[i].name}-${optionValue}`}
                    onChange={(e) => {
                      this._optionChanged(keyName, optionValue);
                    }}
                  />
                  <label
                    htmlFor={`${this.props.product.handle}-${productEn.options_with_values[i].name}-${optionValue}`}
                    className="option-value-name"
                  >
                    <span className="option-value-inner">
                      {optionValueLabel}
                    </span>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );
    });
  }

  formButton() {
    if (this.state.cartButton === "loading") {
      return (
        <button
          className="product-submit action-button submit button-loading"
          data-product-submit
          disabled
          type="submit"
        >
          <div className="button-label-spinner">
            <SVG icon="spinner" />
          </div>
        </button>
      );
    } else if (this.state.cartButton === "success") {
      return (
        <button
          className="product-submit action-button submit button-loading"
          data-product-submit
          disabled
          type="submit"
        >
          {this.context.i18n.addedToCart}
        </button>
      );
    } else if (this.state.cartButton === "error") {
      return (
        <button
          className="product-submit action-button submit button-loading"
          data-product-submit
          disabled
          type="submit"
        >
          {this.context.i18n.addToCartError}
        </button>
      );
    }

    const pov = this.props.currentVariant || this.props.product;

    if (pov.available) {
      return (
        <button
          className="product-submit action-button submit button-active"
          data-product-submit
          type="submit"
        >
          {this.context.i18n.addToCart}
        </button>
      );
    } else if (this.props.product.tags.includes("BIS")) {
      return null;
    } else {
      return (
        <button
          className="product-submit action-button submit addtocart-button-disabled"
          data-product-submit
          disabled
          type="submit"
        >
          {this.context.i18n.soldOut}
        </button>
      );
    }
  }

  waitlist() {
    const pov = this.props.currentVariant || this.props.product;

    if (!pov.available && this.props.product.tags.includes("BIS")) {
      return (
        <Waitlist
          {...this.props}
          key={pov.id}
          _invalidVariant={this._invalidVariant}
        />
      );
    }

    return null;
  }

  formSubmit(e) {
    e.preventDefault();
    if (this.props.currentVariant) {
      this.setState({ cartButton: "loading" });
      const properties = {};

      if (e.detail && e.detail.fitFinder) {
        properties["_From Fit Finder"] = true;
      }
      if (
        this.props.metafields.variants[this.props.currentVariant.id].messaging
          .ship_note
      ) {
        properties["_Ships"] = this.props.metafields.variants[
          this.props.currentVariant.id
        ].messaging.ship_note;
      }

      if (
        this.props.metafields.bundles &&
        this.props.metafields.bundles.ids &&
        this.props.metafields.bundles.ids.length > 0
      ) {
        const bundleIds = this.props.metafields.bundles.ids.map(
          (id) => `gid://shopify/ProductVariant/${id}`
        );
        properties["_bundleIds"] = bundleIds.join(",");
        properties[
          "_bundleQty"
        ] = this.props.metafields.bundles.quantities.join(",");
        properties["_isBundle"] = true;
        properties["_parentHandle"] = this.props.product.handle;
       }
      
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("csm_true") !== null) {
        properties["_CartUpsell"] = "pdp";
      }

      Axios.post("/cart/add.js", {
        id: this.props.currentVariant.id,
        quantity: 1,
        properties: properties,
      }).then(
        () => {
          this.cartMini.refresh().then(() => {
            this.setState({ cartButton: "success" });
            this.cartMini.open(false);
          });

          if (klaviyo) {
            if (
              window.item &&
              window.item.ProductID === this.props.product.id
            ) {
              klaviyo.track("Added to Cart", window.item);
            } else {
              const klaviyoItem = {
                Name: this.props.product.title,
                Brand: this.props.product.vendor,
                Price: formatMoney(
                  this.props.currentVariant.price,
                  Theme.moneyFormat
                ),
                CompareAtPrice: formatMoney(
                  this.props.currentVariant.compare_at_price,
                  Theme.moneyFormat
                ),
                ProductID: this.props.product.id,
                ImageURL: `https:${this.props.product.featured_image}`,
                URL: `${window.location.origin}/products/${this.props.product.handle}`,
              };
              klaviyo.track("Added to Cart", klaviyoItem);
            }
          }

          if (typeof window.twq === "function") {
            window.twq("event", "tw-o41kc-odvdh", {
              currency: "USD",
              value: this.props.currentVariant.price / 100,
              contents: [
                {
                  content_type: this.props.product.type,
                  content_id: this.props.currentVariant.id,
                  content_name: this.props.currentVariant.name,
                  content_price: this.props.currentVariant.price / 100,
                  content_group_id: this.props.product.id,
                },
              ],
            });
          }

          /* trackEvent('add_to_cart', {
          currency: 'USD',
          value: this.props.currentVariant.price / 100,
          items: [
            {
              item_id: this.props.product.handle,
              item_name: this.props.product.title,
              price: this.props.currentVariant.price / 100,
              currency: 'USD',
              item_brand: this.props.product.vendor,
              item_category: this.props.product.type,
              item_variant: this.props.currentVariant.title,
              quantity: 1
            }
          ]
        }); */

          let location = "Main Button";
          if (e.detail && e.detail.fitFinder) {
            location = "Sizing Quiz";
          }

          trackEvent("ProductATC", {
            title: this.props.product.title,
            vendor: this.props.product.vendor,
            price: this.props.currentVariant.price,
            handle: this.props.product.handle,
            sku: this.props.currentVariant.sku,
            location: location,
          });
        },
        (fail) => {
          this.setState({ cartButton: "error" });
          console.error(fail);
        }
      );
    } else {
      this._invalidVariant();
    }
  }

  shipNote() {
    if (
      this.props.currentVariant &&
      this.props.currentVariant.available &&
      this.props.metafields.variants[this.props.currentVariant.id].messaging
        .ship_note
    ) {
      let shipModalContent = this.props.settings.shipModalContent.replace(
        "XXX__XXX",
        this.props.metafields.variants[
          this.props.currentVariant.id
        ].messaging.ship_note.toLowerCase()
      );

      return (
        <div className="inventory-message-wrapper">
          <p className="inventory-message">
            {
              this.props.metafields.variants[this.props.currentVariant.id]
                .messaging.ship_note
            }
            <a href="#" aria-label="Info" onClick={this._openShipModal}>
              <SVG icon="info" />
            </a>
          </p>
          <Drawer
            open={this.state.shipModalOpen}
            heading={this.props.settings.shipModalHeading}
            content={shipModalContent}
            contentClass="pricing-philosophy-how-we-do-it"
            _close={this._closeShipModal}
            mountOnEnter={false}
            unmountOnExit={true}
          />
        </div>
      );
    }
    return null;
  }

  inventoryAlert() {
    if (
      this.props.currentVariant &&
      this.props.currentVariant.available &&
      this.props.currentVariant.inventory_management === "shopify" &&
      this.props.currentVariant.inventory_policy === "deny" &&
      this.props.currentVariant.inventory_quantity <= 10
    ) {
      return (
        <div className="inventory-alert">
          <div className="inventory-alert-text">
            {this.props.currentVariant.inventory_quantity <= 3
              ? `Only ${this.props.currentVariant.inventory_quantity} left!`
              : `Only a few left!`}
          </div>
        </div>
      );
    }
    return null;
  }

  componentDidMount() {
    window.addEventListener("fitFinder:add", this.formSubmit);
  }

  componentDidUpdate() {
    if (
      this.state.cartButton === "error" ||
      this.state.cartButton === "success"
    ) {
      this.timeout = setTimeout(() => {
        this.setState({ cartButton: "" });
      }, 1000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("fitFinder:add", this.formSubmit);
    clearTimeout(this.timeout);
  }

  render() {
    const colorsProps = {
      productGroup: this.props.productGroup,
      desktopProductGroup: this.props.desktopProductGroup,
      product: {
        ...this.props.product,
        color_label: this.props.metafields.colorLabel,
      },
      option1: this.props.option1,
      onColorChange: this.props.onColorChange,
      onProductChange: this.props.onProductChange,
      metafields: this.props.metafields,
      currentVariant: this.props.currentVariant,
      delegate: this.props.metafields.thumbnails.delegate,
    };

    return (
      <div className="options" ref={this.ref}>
        <form
          method="POST"
          action="/cart/add"
          className="product-form"
          encType="multipart/form-data"
          onSubmit={this.formSubmit}
        >
          <ProductSwitcher {...this.props} />
          <ProductColors {...colorsProps} />
          <LowerProductSwitcher {...this.props} />
          <this.formData />
          <ProductPromos
            product={this.props.product}
            metafields={this.props.metafields}
            blocks={this.props.blocks}
            position="above-atc"
            _openSizeGuide={this.props._openSizeGuide}
            _openFitGuide={this.props._openFitGuide}
            _optionChanged={this.props.onOptionChange}
            sizeGuides={this.props.sizeGuides}
          />
          <EstimatedDelivery blocks={this.props.blocks} position="above-atc" />
          <this.inventoryAlert />
          <this.shipNote />
          <this.formButton />
        </form>
        <this.waitlist />
        <ProductPromos
          product={this.props.product}
          metafields={this.props.metafields}
          blocks={this.props.blocks}
          position="below-atc"
          _openSizeGuide={this.props._openSizeGuide}
          _openFitGuide={this.props._openFitGuide}
          _optionChanged={this.props.onOptionChange}
          sizeGuides={this.props.sizeGuides}
        />
        <EstimatedDelivery blocks={this.props.blocks} position="below-atc" />
      </div>
    );
  }
}

ProductForm.contextType = ProductContext;
